import { HTMLAttributes } from 'react'

import Image from '@/components/base/Image'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

export type SolidCardProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    icon: WPImage
    color: string
    theme: 'light' | 'dark'
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    title: string
    paragraph: string
  }>

const SolidCard = ({
  color,
  theme,
  icon,
  title,
  title_variant,
  title_component,
  paragraph,
  className,
  ...props
}: SolidCardProps) => {
  return (
    <div
      className={cn([
        'flex h-full w-full flex-col space-y-[1rem] rounded-[3rem] bg-mainbody p-gutter text-center md:space-y-[1.5rem]',
        className
      ])}
      style={{ backgroundColor: color }}
      {...props}
    >
      {icon && icon.url ? (
        <div className="relative inline-flex h-[6rem] w-auto justify-center">
          <Image source={icon} className="h-full w-auto" />
        </div>
      ) : null}

      {title || paragraph ? (
        <div className="flex flex-col space-y-[.5rem] md:space-y-[1.5rem]">
          {title ? (
            <Typography
              variant={title_variant}
              component={title_component}
              className={cn([
                {
                  'text-white': theme === 'light',
                  'text-dark-blue': theme === 'dark'
                }
              ])}
            >
              {title}
            </Typography>
          ) : null}

          {paragraph ? (
            <Typography
              variant="body"
              paragraph
              className={cn([
                {
                  'text-white': theme === 'light',
                  'text-dark-blue': theme === 'dark'
                }
              ])}
            >
              {paragraph}
            </Typography>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default SolidCard
